import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';


import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import EngineeringIcon from '@mui/icons-material/Engineering';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import ShieldIcon from '@mui/icons-material/Security';
import BedIcon from '@mui/icons-material/Bed';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';

const PRIMARY_COLOR = '#0057A4';
const SECONDARY_COLOR = '#CE8238';

const iconList = [
  <EngineeringIcon />,
  <MedicalServicesIcon />,
  <NetworkWifiIcon />,
  <ShieldIcon />,
  <BedIcon />,
  <LocalHospitalIcon />,
  <AccessibilityNewIcon />,
];

const Services3D = () => {
  const { t } = useTranslation();
  const services = t("services", { returnObjects: true });

  return (
    <Box sx={{ px: 4, py: 6, minHeight: '100vh' }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          background: PRIMARY_COLOR,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: 700,
          letterSpacing: 3,
          textTransform: "uppercase",
          width: "100%",
          fontSize: "40px",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          mb: 5,
        }}
      >
        {t("ourServices")}
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              whileHover={{ rotateX: 8, rotateY: 8, scale: 1.05 }}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              style={{ transformStyle: 'preserve-3d', perspective: '1200px' }}
            >
              <Card
                sx={{
                  borderRadius: '30px',
                  background: 'lightgray',
                  padding: 3,
                  boxShadow: '0 25px 60px rgba(0,0,0,0.12)',
                  minHeight: '200px',
                  borderTop: `10px solid ${SECONDARY_COLOR}`,
                  borderLeft: `10px solid ${PRIMARY_COLOR}`,
                  '&:hover': {
                    boxShadow: '0 30px 80px rgba(0,0,0,0.18)',
                  }
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 70,
                      height: 70,
                      border: `2px solid ${PRIMARY_COLOR}`,
                      borderRadius: '50%',
                      backgroundColor: "white",
                      color: PRIMARY_COLOR,
                      fontSize: '40px',
                      mb: 2,
                      boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                    }}
                  >
                    {iconList[index]}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#222', mb: 1 }}>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.6 }}>
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Services3D;
